<template>
  <div>
    <head-nav-bar title="客户详情" :fixed="true" @click-left="tolist" />
    <div class="mt-header-nav">
      <div class="card">
        <div class="card-title">基本信息</div>
        <div class="card-content">
          <cell-box :column="2" labelAlign="right">
            <cell-item label="客户类别：">
              <template slot="value">
                <div class="text-hide">{{ userDetail.CustomerTypeName }}</div>
              </template>
            </cell-item>
            <cell-item label="客户编号：" :value="userDetail.Code" />
            <cell-item label="客户姓名：" :value="userDetail.Name" />
            <cell-item label="简称：" :value="userDetail.ShortName" />
            <cell-item label="合同编号：" :value="userDetail.ContractNo" />
            <cell-item label="销售员：" :value="userDetail.Salesman" />
            <cell-item label="联系人：" :value="userDetail.Contacts" />
            <cell-item label="联系电话：" :value="userDetail.ContactsInfo" />
          </cell-box>
        </div>
      </div>
      <div class="card">
        <div class="card-title">挂账信息</div>
        <div class="card-content">
          <cell-box :column="2" labelAlign="right">
            <cell-item label="挂账标志：" :value="userDetail.SignText" />
            <cell-item label="总限额：" :value="userDetail.TotalLimit" />
            <cell-item label="单次限额：" :value="userDetail.SingleTimeLimit" />
            <cell-item label="可用余额：">
              <template slot="value">
                <div style="color: red;">{{ userDetail.Rest }}</div>
              </template>
            </cell-item>
          </cell-box>
          <cell-box :column="1">
            <cell-item label="有效日期：" :value="Time" />
          </cell-box>
        </div>
      </div>
      <div class="card">
        <div class="card-title">其它信息</div>
        <div class="card-content">
          <cell-box :column="2" labelAlign="right">
            <cell-item label="集团客户：" :value="IsGroup" />
            <cell-item label="价类：" :value="userDetail.PriceCodeText" />
          </cell-box>
        </div>
      </div>
    </div>
    <van-goods-action>
      <van-goods-action-button
        type="info"
        text="修改资料"
        style="width:50%"
        @click="editUser()"
      />
      <van-goods-action-button
        v-if="IsDelete"
        type="danger"
        text="删除"
        style="width:50%"
        @click="deleteUser()"
      />
    </van-goods-action>
  </div>
</template>
<script>
import { CellBox, CellItem } from "@/components/cell";
import { getOneUserDetail, Delete } from "@/api/user.js";
import { Notify, GoodsAction, GoodsActionButton } from "vant";
export default {
  components: {
    CellBox,
    CellItem,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionButton.name]: GoodsActionButton,
  },
  data() {
    return {
      userId: 0,
      Time: "",
      IsGroup: "",
      IsDelete: true,
      userDetail: [],
    };
  },
  created() {
    this.userId = this.$route.query.id;
    if (!this.userId) {
      Notify("缺少Id字段值!");
      this.$router.go(-1);
    }
    getOneUserDetail({ Id: this.userId }).then(res => {
      this.userDetail = res.Data;
      this.IsGroup = this.userDetail.IsGroup ? "是" : "否";
      this.IsDelete = this.userDetail.IsGroup ? false : true;
      this.Time =
        this.userDetail.StartTime != undefined
          ? this.userDetail.StartTime + " - " + this.userDetail.EndTime
          : " ";
    });
  },
  methods: {
    tolist() {
      this.$router.push({
        name: "UserList",
      });
    },
    editUser() {
      this.$router.push({
        name: "EditUser",
        query: { type: 2, id: this.userId },
      });
    },
    deleteUser() {
      Delete({ Id: this.userId }).then(() => {
        Notify("删除成功");
        this.$router.push({ name: "UserList" });
      });
    },
  },
};
</script>
<style lang="less">
.text-hide {
  display: inline-block;
  width: calc(100% - 20px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
